import { render, staticRenderFns } from "./item-subject.vue?vue&type=template&id=590a3c6c&scoped=true&"
import script from "./item-subject.vue?vue&type=script&lang=js&"
export * from "./item-subject.vue?vue&type=script&lang=js&"
import style0 from "./item-subject.vue?vue&type=style&index=0&id=590a3c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a3c6c",
  null
  
)

export default component.exports